<script setup lang="js">
import { ref, onMounted, computed } from 'vue';
import { storeToRefs } from 'pinia';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';

import { useRouteParams } from '@vueuse/router';
import { useAutoformStore } from '@/stores/autoform.store';
import { useProjectStore } from '@/stores/project.store';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';

const autoformStore = useAutoformStore();
const projectStore = useProjectStore();
const { closeModal } = useModal();
const projectId = useRouteParams('projectId');

const { custom_variables, mapLayers, selectedMapLayersIndex } = storeToRefs(autoformStore);
const { project } = storeToRefs(projectStore);

const variable = ref(null);

const options = computed(() => {
  return custom_variables.value.filter((variable) => variable.type === 'map_layers');
});

function createAutoCatalog() {
  if (_.isNil(selectedMapLayersIndex.value)) {
    mapLayers.value.push(variable.value.name);
  } else {
    mapLayers.value[selectedMapLayersIndex.value] = variable.value.name;
  }

  closeModal();
}

onMounted(() => {
  if (!project.value.locales) {
    projectStore.getProject(projectId.value);
  }
});
</script>

<template>
  <ModalTemplateSide @submit="createAutoCatalog">
    <template v-slot:title>Добавить слои для вывода на карту</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Переменная слоёв</label>

        <Multiselect
          v-model="variable"
          :options="options"
          placeholder="Выбрать..."
          :multiple="false"
          label="title"
          track-by="name"
          class="multiselect-style"
        />
      </div>
    </template>
    <template v-slot:submit>Добавить</template>
  </ModalTemplateSide>
</template>
